<script lang="jsx">
import { actions, namespace } from '@/store/modules/postalNewCustomer'
import DigitalYuanNumber from '@/views/postalNewCustomer/DigitalYuanNumber'
import { Popup } from 'vant';
import { mapActions } from 'vuex';

const prizes = {
  'cdf66805-35b5-49bf-afed-2fef676e684f': require('@/assets/images/postalNewCustomer/shi_wang_kou_pen.png'),
  '453adefe-7c54-4b4b-89ea-462f45381bca': require('@/assets/images/postalNewCustomer/shi_wang_xi_shou_ye.png'),
  'acc4a21b-27e8-44bd-afbf-5001f5015c4d': require('@/assets/images/postalNewCustomer/shi_wang_shu_kou_shui.png'),
  '56db0a70-4b87-4ab5-92fe-7f0ea7eaeb82': require('@/assets/images/postalNewCustomer/fan_bu_dai.png'),
  drawCount: require('@/assets/images/postalNewCustomer/drawCount.png')
}
const digitalYuanRewardIds = [
  'a8638ea8-2e05-4e00-a7ca-b4f7f2a397df', 'c300db21-66ce-41b3-8332-35b8d9690a29',
  '524bdd29-b582-4bb5-9b55-95af5e1b9824', '52bbc48b-61dc-4938-bf01-b80007310a63'
]

export default {
  name: "WriteOffModal",
  components: { Popup },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    prizeId: [String, Number],
    type: {
      type: String,
      validate: val => ['get','received', undefined].includes(val)
    },
    prizeTypeCode: String,
  },
  data() {
    return {
      writeOffCode: '',
      MATERIAL: 'material'
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    deviceCoding() {
      const localDeviceCoding = localStorage.getItem('deviceCoding');
      return this.$store.state.user.deviceCoding || localDeviceCoding;
    },
    token() {
      const localToken = localStorage.getItem('token');
      return this.$store.state.user.token || localToken;
    },
    prizeImg() {
      return prizes[this.prizeTypeCode]
    }
  },
  methods: {
    ...mapActions(namespace, {
      writeOffReward: actions.WRITE_OFF_REWARD
    }),
    async handleWriteReward() {
      if (!this.writeOffCode) {
        this.$toast('请输入核销密码');
        return;
      }
      const params = {
        code: this.writeOffCode,
        id: this.prizeId,
      };
      const res = await this.writeOffReward(params);
      if (res.data) {
        this.$emit('success');
      } else {
        this.$toast('核销失败，请检查核销密码');
      }
    },
    handleCopy() {
      if (navigator.clipboard) {
        // clipboard api 复制
        navigator.clipboard.writeText('lcago0628').then(() => {
            this.$toast('复制成功');
        }).catch(err=>{
          this.copy()
        })
      } else {
        this.copy()
      }
    },
    copy(){
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea);
        textarea.style.position = 'fixed';
        textarea.style.clip = 'rect(0 0 0 0)';
        textarea.style.top = '10px';
        textarea.value = 'lcago0628';
        textarea.select();
        document.execCommand('copy', true);
        document.body.removeChild(textarea);
        this.$toast('复制成功');
    }
  },
  render(h) {
    const prizeImg = h('img', {
      class: 'prize-img',
      attrs: {
        alt: '',
        src: this.prizeImg
      }
    })
    const kindRewardContent = (
      <div>
        { prizeImg }
        <div class="write-off-no-input">
          <input
            class="write-off-no-input__inner"
            readonly
            type="text"
            value="客服微信号：lcago0628"
          />
          <img
            alt=""
            class="copy-icon"
            src={ require('../../assets/images/postalNewCustomer/copy-icon.png') }
            onClick={ this.handleCopy }
          />
        </div>
        <p class="tips">*添加客服微信领取实物奖励</p>
      </div>
    )
    return (
      <popup
        value={ this.show }
        { ...{
          on: {
            'input': (val) => {
              this.show = val
            },
            close: () => {
              this.show = false
            }
          }
        }
        }
      >
        {
          digitalYuanRewardIds.includes(this.prizeTypeCode)
            ? h(DigitalYuanNumber, { props: { id: this.prizeTypeCode } })
            : kindRewardContent
        }
        {
          this.type === 'get'
            ? <img
              alt=""
              class="submit-btn"
              src={ require('@/assets/images/postalNewCustomer/turntable/popup_btn_get.png') }
              onClick={ () => {
                this.show = false
              } }
            />
            : <img
              alt=""
              class="submit-btn"
              src={ require(`@/assets/images/postalNewCustomer/turntable/popup_btn_${this.type === ''?'received':'know'}.png`) }
              onClick={ () => {
                this.show = false
              } }
            />
        }
      </popup>
    )
  }
}
</script>

<style lang="scss" scoped>
@import "./components/function";

.van-popup {
    background: transparent;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .prize-img {
        // width: 100%;
        width: pxvw(532);
        height: auto;
    }

    .write-off-no-input {
        width: 92%;
        height: pxvw(80);
        border-radius: px2rem(40);
        background-color: rgba(0, 0, 0, 0.8);
        margin: pxvw(-68) auto 0;
        border: 2px solid #99977c;
        z-index: 10;
        position: relative;
        box-shadow: inset 0 0 px2rem(30) px2rem(10) #99977c;
        display: flex;
        align-items: center;

        .write-off-no-input__inner {
            height: 100%;
            width: 100%;
            border-radius: px2rem(40);
            background-color: transparent;
            border: none;
            color: #ffffff;
            font-size: px2rem(32);
            text-align: center;
            flex: 1;
        }

        .copy-icon {
            //position: absolute;
            //right: px2rem(30);
            //top: 50%;
            //transform: translateY(-50%);
            width: px2rem(32);
            height: auto;
            margin-right: px2rem(32);
        }
    }

    .tips {
        width: 80%;
        color: #ff4b33;
        font-size: px2rem(20);
        text-align: center;
        margin: px2rem(24) auto;
    }

    .submit-btn {
        width: 70%;
        height: auto;
        display: block;
        margin: 0 auto;
    }
}
</style>
